import useMultiPortfolioStore from 'lib/stores/multiPorto';
import useSubAccounts from 'features/multi-porto/hooks/useSubAccounts';
import useSwitchAction from 'features/multi-porto/hooks/useSwitchAction';

import If from 'global/Common/If';
import Image from 'global/Image';
import SwitchPopover from 'features/multi-porto/components/SwitchPopover';
import { formatCurrency } from 'features/securities/withdrawal/utils';
import { getRoundDownValue } from 'features/securities/utils';

import { Skeleton } from 'antd';
import {
  Container,
  SwitchContainer,
  SwitchInfoContainer,
  SwitchInfoItem,
  CreateButton,
  TransferContainer,
  TransferButton,
} from './switch.styled';

interface SwitchPortfolioProps {
  onClick?: () => void;
}

export default function SwitchAccount({
  onClick = () => {},
}: Readonly<SwitchPortfolioProps>) {
  const tradingBalance = useMultiPortfolioStore(
    (s) => s.tradingBalanceData.data,
  );
  const tradingBalanceLoading = useMultiPortfolioStore(
    (s) => s.tradingBalanceData.isLoading,
  );

  const { subAccounts, approvedSubAccounts, subAccountError } =
    useSubAccounts();

  const subAccountsLength = approvedSubAccounts.length;

  const { onOpenTransferCash, onOpenTransferStock, onCreatePortfolio } =
    useSwitchAction();

  const handleClickTransferCash = () => {
    onClick();
    onOpenTransferCash();
  };

  const handleClickTransferStock = () => {
    onClick();
    onOpenTransferStock();
  };

  const handleCreatePortfolio = () => {
    onClick();
    onCreatePortfolio();
  };

  const formatBalance = (balance: number) =>
    formatCurrency(String(getRoundDownValue(balance, 0)));

  return (
    <Container>
      <SwitchContainer>
        <SwitchInfoContainer>
          <SwitchInfoItem>
            <h1>Total Trading Balance</h1>

            <If condition={tradingBalanceLoading && !tradingBalance.balance}>
              <Skeleton.Input active />
              <If.Else>
                <p>{formatBalance(tradingBalance.balance)}</p>
              </If.Else>
            </If>
          </SwitchInfoItem>
          <SwitchInfoItem>
            <h1>Total Equity</h1>

            <If condition={tradingBalanceLoading && !tradingBalance.equity}>
              <Skeleton.Input active />
              <If.Else>
                <p>{formatBalance(tradingBalance.equity)}</p>
              </If.Else>
            </If>
          </SwitchInfoItem>
        </SwitchInfoContainer>

        <If condition={subAccounts.length <= 1 && !subAccountError}>
          <CreateButton onClick={handleCreatePortfolio}>
            <Image src="/icon/plus/primary.svg" alt="" width={16} height={16} />

            <span>Create New Portfolio</span>
          </CreateButton>
        </If>

        <If condition={subAccounts.length > 1}>
          <SwitchPopover hideTransfer width={268} placement="bottom" />
        </If>
      </SwitchContainer>

      <If condition={subAccountsLength > 1}>
        <TransferContainer>
          <TransferButton onClick={handleClickTransferCash}>
            <Image
              src="/icon/multi-porto/transfer-cash.svg"
              alt=""
              width={14}
              height={14}
            />
            <span>Transfer Cash</span>
          </TransferButton>
          <TransferButton onClick={handleClickTransferStock}>
            <Image
              src="/icon/multi-porto/transfer-stock.svg"
              alt=""
              width={14}
              height={14}
            />
            <span>Transfer Stock</span>
          </TransferButton>
        </TransferContainer>
      </If>
    </Container>
  );
}
